import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useOpts } from '../../../context';
import eventQueue from '../../../events/queue';
import useLinkNavigate from '../../../hooks/useLinkNavigate';
import { noop } from '../../../utils';
import { defaultSearchState } from '../../../utils/navigation';
import { setAdpAuth } from '../../../state/slices/slice-adp-direct';
var useGetActionOnClick = function (action, onSubmit) {
    if (onSubmit === void 0) { onSubmit = noop; }
    var opts = useOpts();
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var onClick = useMemo(function () {
        if (action.actionType === 'payload') {
            return function (e) {
                e.preventDefault();
                if (action.payload.account_recovery_step_key === 'account_recovery') {
                    var newCheckpoints = new Set(opts.checkpoints);
                    newCheckpoints.add('account_recovery');
                    opts.setCheckpoints(newCheckpoints);
                }
                eventQueue.emit('link_api_action', {
                    action: action,
                });
                onSubmit(action.payload);
            };
        }
        if (action.actionType === 'search') {
            return function () {
                var _a;
                eventQueue.emit('link_api_action', {
                    action: action,
                });
                if (((_a = action.queryParams) === null || _a === void 0 ? void 0 : _a.response_types) === 'platform') {
                    navigate('/search/platforms');
                }
                else {
                    navigate(defaultSearchState());
                }
            };
        }
        if (action.actionType === 'hyperlink') {
            return noop;
        }
        if (action.actionType === 'adp_iframe') {
            return function () {
                dispatch(setAdpAuth(action.iframeAuthData));
                eventQueue.emit('link_api_action', {
                    action: action,
                });
                navigate('/adp_iframe');
                onSubmit({});
            };
        }
        return function () {
            eventQueue.emit('link_api_action', {
                action: action,
            });
            action.callback();
        };
    }, [action, dispatch, navigate, onSubmit, opts]);
    return onClick;
};
export default useGetActionOnClick;
